

export const useAppStore = defineStore('app', () => {
  // 应用状态
  const sidebarCollapsed = ref(false)
  const mobileSidebarOpen = ref(false)
  const theme = ref('light')
  const language = ref('zh-CN')
  const loading = ref(false)
  const notifications = ref([])
  const isMobile = ref(false)

  // 计算属性：根据设备类型判断侧边栏状态
  const sidebarVisible = computed(() => {
    if (isMobile.value) {
      return mobileSidebarOpen.value
    }
    return !sidebarCollapsed.value
  })

  // 切换侧边栏
  const toggleSidebar = () => {
    if (isMobile.value) {
      mobileSidebarOpen.value = !mobileSidebarOpen.value
    } else {
      sidebarCollapsed.value = !sidebarCollapsed.value
      localStorage.setItem('sidebarCollapsed', JSON.stringify(sidebarCollapsed.value))
    }
  }

  // 设置侧边栏状态
  const setSidebarCollapsed = (collapsed) => {
    if (isMobile.value) {
      mobileSidebarOpen.value = !collapsed
    } else {
      sidebarCollapsed.value = collapsed
      localStorage.setItem('sidebarCollapsed', JSON.stringify(collapsed))
    }
  }

  // 关闭移动端侧边栏
  const closeMobileSidebar = () => {
    if (isMobile.value) {
      mobileSidebarOpen.value = false
    }
  }

  // 设置移动端状态
  const setMobileState = (mobile) => {
    isMobile.value = mobile
    if (mobile) {
      mobileSidebarOpen.value = false
    }
  }

  // 切换主题
  const toggleTheme = () => {
    theme.value = theme.value === 'light' ? 'dark' : 'light'
    localStorage.setItem('theme', theme.value)
  }

  // 设置主题
  const setTheme = (newTheme) => {
    theme.value = newTheme
    localStorage.setItem('theme', newTheme)
  }

  // 设置语言
  const setLanguage = (lang) => {
    language.value = lang
    localStorage.setItem('language', lang)
  }

  // 设置加载状态
  const setLoading = (status) => {
    loading.value = status
  }

  // 添加通知
  const addNotification = (notification) => {
    const id = Date.now().toString()
    notifications.value.push({
      id,
      ...notification,
      timestamp: new Date()
    })

    // 自动移除通知（5秒后）
    setTimeout(() => {
      removeNotification(id)
    }, 5000)
  }

  // 移除通知
  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  // 清空所有通知
  const clearNotifications = () => {
    notifications.value = []
  }

  // 初始化应用配置
  const initAppConfig = () => {
    // 从localStorage恢复配置
    const savedTheme = localStorage.getItem('theme')
    const savedLanguage = localStorage.getItem('language')
    const savedSidebarCollapsed = localStorage.getItem('sidebarCollapsed')

    if (savedTheme) theme.value = savedTheme
    if (savedLanguage) language.value = savedLanguage
    if (savedSidebarCollapsed) sidebarCollapsed.value = JSON.parse(savedSidebarCollapsed)

    // 检测移动端
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768
      setMobileState(mobile)
    }

    // 初始检测
    checkMobile()

    // 监听窗口大小变化
    window.addEventListener('resize', checkMobile)

    // 返回清理函数
    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }

  return {
    // 状态
    sidebarCollapsed,
    mobileSidebarOpen,
    theme,
    language,
    loading,
    notifications,
    isMobile,

    // 计算属性
    sidebarVisible,

    // 方法
    toggleSidebar,
    setSidebarCollapsed,
    closeMobileSidebar,
    setMobileState,
    toggleTheme,
    setTheme,
    setLanguage,
    setLoading,
    addNotification,
    removeNotification,
    clearNotifications,
    initAppConfig
  }
})
